import React from 'react';
import Link from 'next/link';
import { breakpoints, color, font } from '../../styles/theme';
import { Paths } from '../../urls/Paths';

const HeroSection: React.FC = () => {
  return (
    <div className="hero-section">
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">
          Golf{' '}
          <img src="/x-imt.svg" alt="x" className="hero-title-accent-logo" />{' '}
          Viro{' '}
          <img src="/x-imt.svg" alt="x" className="hero-title-accent-logo" />{' '}
          IMT.fi
        </h1>
        <p className="hero-subtitle">
          Täydellinen golfreissu odottaa lahden takana.
        </p>
        <p className="hero-trust">
          Olemme vieneet yli miljoona vapaa-ajanmatkustajaa Viroon vuodesta
          1991.
        </p>
        <div className="hero-buttons">
          <Link href="/matkat" passHref legacyBehavior>
            <a className="hero-btn hero-btn-primary">Tutustu matkoihin</a>
          </Link>
          <Link href={Paths.DestinationList} passHref legacyBehavior>
            <a className="hero-btn hero-btn-secondary">Katso kentät</a>
          </Link>
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <div className="scroll-arrow" />
      </div>
      {/*language=CSS*/}
      <style jsx>{`
        .hero-section {
          position: relative;
          background-image: url('/golf_hero.jpg');
          background-size: cover;
          background-position: center;
          height: 100vh;
          min-height: 600px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: ${color.white};
          text-align: center;
          width: 100vw;
          margin-left: calc(-50vw + 50%);
        }

        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.35) 0%,
            rgba(0, 0, 0, 0.5) 50%,
            rgba(0, 0, 0, 0.6) 100%
          );
          z-index: 1;
        }

        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          padding: 0 24px;
        }

        .hero-title {
          font-family: ${font.primary};
          font-size: 3rem;
          font-weight: 700;
          margin: 0 0 20px;
          line-height: 1.1;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        }

        .hero-title-accent-logo {
          height: 0.6em;
          vertical-align: baseline;
          margin: 0 12px;
          filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3));
        }

        .hero-subtitle {
          font-family: ${font.primary};
          font-size: 1.5rem;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.95);
          margin: 0 0 12px;
          line-height: 1.4;
          text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
        }

        .hero-trust {
          font-family: ${font.primary};
          font-size: 0.95rem;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          margin: 0 0 40px;
          line-height: 1.5;
          text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        }

        .hero-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .hero-btn {
          display: inline-block;
          padding: 14px 36px;
          font-family: ${font.primary};
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          text-decoration: none;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          letter-spacing: 0.02em;
        }

        .hero-btn-primary {
          background: ${color.coral};
          color: ${color.white};
          border: 2px solid ${color.coral};
          box-shadow: 0 4px 20px rgba(232, 74, 92, 0.35);
        }

        .hero-btn-primary:hover {
          background: #d13a52;
          border-color: #d13a52;
          transform: translateY(-3px);
          box-shadow: 0 8px 30px rgba(232, 74, 92, 0.45);
          color: ${color.white};
        }

        .hero-btn-secondary {
          background: transparent;
          color: ${color.white};
          border: 2px solid rgba(255, 255, 255, 0.7);
        }

        .hero-btn-secondary:hover {
          background: rgba(255, 255, 255, 0.15);
          border-color: ${color.white};
          transform: translateY(-3px);
          color: ${color.white};
        }

        .hero-scroll-indicator {
          position: absolute;
          bottom: 32px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
        }

        .scroll-arrow {
          width: 24px;
          height: 24px;
          border-right: 2px solid rgba(255, 255, 255, 0.6);
          border-bottom: 2px solid rgba(255, 255, 255, 0.6);
          transform: rotate(45deg);
          animation: scrollBounce 2s infinite;
        }

        @keyframes scrollBounce {
          0%,
          100% {
            transform: rotate(45deg) translateY(0);
            opacity: 0.6;
          }
          50% {
            transform: rotate(45deg) translateY(8px);
            opacity: 1;
          }
        }

        @media ${breakpoints.medium} {
          .hero-title {
            font-size: 4.5rem;
          }
          .hero-subtitle {
            font-size: 1.75rem;
          }
          .hero-trust {
            font-size: 1rem;
          }
          .hero-btn {
            padding: 16px 44px;
            font-size: 1.05rem;
          }
        }
      `}</style>
    </div>
  );
};

export default HeroSection;
